import styled from "@emotion/native"
import { Avatar, Spacing, Text, TextProps } from "./"
import { getInitials } from "../utils"
import { ReactNode } from "react"
import { functionalColors } from "./colors.ts"
import { ViewStyle } from "react-native"

type ListItemProps = {
  name?: string
  logoColor?: string
  rightElement?: ReactNode
  leftElement?: ReactNode
  description?: string
  descriptionColor?: keyof (typeof functionalColors)["text"]
  onPress: () => void
  nameTextProps?: TextProps
  descriptionTextProps?: TextProps
  containerStyle?: ViewStyle
}

export function ListItem(props: ListItemProps) {
  const {
    name,
    logoColor,
    onPress,
    description,
    descriptionColor = "tertiary",
    rightElement,
    nameTextProps,
    descriptionTextProps,
    containerStyle,
    leftElement = (
      <>
        <Avatar initials={name ? getInitials(name) : ""} color={logoColor} />
        <Spacing right={12} />
      </>
    ),
  } = props

  return (
    <ItemContainer style={containerStyle}>
      <StyledPressable onPress={onPress}>
        {leftElement}
        <ItemName>
          <Text type="label2" {...nameTextProps}>
            {name}
          </Text>
          {!!description && (
            <Text color={descriptionColor} {...descriptionTextProps}>
              {description}
            </Text>
          )}
        </ItemName>
        {rightElement}
      </StyledPressable>
    </ItemContainer>
  )
}

const ItemContainer = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ItemName = styled.View`
  flex: 1;
  justify-content: center;
  gap: 4px;
`

const StyledPressable = styled.Pressable`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
`
